/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createContext } from 'react';

const AnalyticsActionsContext = createContext({
  trackAction: () => null
});

export default AnalyticsActionsContext;
